import React, { createContext, FunctionComponent, useState } from 'react';
import config from 'config/config';
import { AppContext, LanguageTypes } from 'types/global';
import { getInitialLanguage, setCookieLanguage } from 'utils/languages';

interface OwnProps {}

type LanguageProviderProps = OwnProps;

export const LanguageContext = createContext<AppContext>({
  previousLanguage: 'pl',
  language: 'pl',
  setLanguage: () => {},
  setLoading: () => {},
  loading: false,
});

export const LanguageProvider: FunctionComponent<LanguageProviderProps> = props => {
  const setLanguage = (language: LanguageTypes) => {
    setState({
      ...state,
      ...(language && { previousLanguage: state.language }),
      ...(language && config.languages.includes(language) && { language }),
    });
    setCookieLanguage(language);
  };

  const setLoading = (loading: boolean) => {
    setState({
      ...state,
      ...(loading && { loading }),
    });
  };

  const initState = {
    previousLanguage: getInitialLanguage(),
    language: getInitialLanguage(),
    loading: false,
    setLanguage,
    setLoading,
  };

  const [state, setState] = useState(initState);

  return <LanguageContext.Provider value={state}>{props.children}</LanguageContext.Provider>;
};
